import { Link, useNavigate } from "react-router-dom";
import { getUserId, clearUserId } from "../lib/api";
import { BarChart3, FolderOpen, Plus, LogOut } from "lucide-react";

export default function Layout({ children, showNav = true }) {
  const userId = getUserId();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearUserId();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      {showNav && (
        <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/85 backdrop-blur">
          <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
            <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
              <div className="flex h-8 w-8 items-center justify-center rounded-md bg-[#0052FF] text-white">
                <BarChart3 size={18} strokeWidth={1.8} />
              </div>
              <div className="font-heading text-lg font-medium tracking-tight">
                Handoff<span className="text-slate-400">.</span>
              </div>
            </Link>
            {userId && (
              <nav className="flex items-center gap-2">
                <Link
                  to="/new"
                  className="hidden items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900 md:inline-flex"
                  data-testid="nav-new-briefing"
                >
                  <Plus size={16} strokeWidth={1.8} />
                  New briefing
                </Link>
                <Link
                  to="/briefings"
                  className="hidden items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900 md:inline-flex"
                  data-testid="nav-saved-briefings"
                >
                  <FolderOpen size={16} strokeWidth={1.8} />
                  Saved
                </Link>
                <button
                  onClick={handleLogout}
                  className="ml-2 inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900"
                  data-testid="nav-logout"
                >
                  <LogOut size={16} strokeWidth={1.8} />
                  <span className="hidden md:inline">Sign out</span>
                </button>
              </nav>
            )}
          </div>
        </header>
      )}
      <main>{children}</main>
    </div>
  );
}
